import { useNavigate, useParams } from "react-router-dom";
import { UrlPath } from "../../config/routeConfig";
import {getMktSecValuationByAsset, getAssetLotByPortfolio,insertorUpdateMktSec,DownloadMktSecFile,deleteMktSec,getMktSecimport,getUserPageAccess, getAssetShareClassddl, insertNewAssetLot} from "../../config/apiConfig";
import { SBAComboBox, SBADropDown } from "../UiComponents/SBADropDown";
import { SBDatePicker } from "../UiComponents/SBDatePicker";
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../shared/topBar/TopBar";
import moment from "moment";
import { useEffect, useState,Component ,useRef,useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPortFolioListAction } from "../actions/portfolioAction";
import { getAssestListddlAction } from "../actions/assetsddlAction";
import { getPortfolioMarketableList } from "../../config/apiConfig";
import { getAsset } from "../actions/assetAction";
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from "../utils/sbaAxios";
import {  DatePicker } from "@progress/kendo-react-dateinputs";
import { exportToExcelUsingRef } from '../utils/excelExporter';
import download from "../../Images/download.svg";
import { ToastContainer, toast } from "react-toastify";
import { SBNotify } from "../utils/sbNotify";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import {
  LoadingScreen,
} from "../UiComponents/LoadingComponent";
import { SBADrawer } from "../UiComponents/SBADrawer";
import * as XLSX from 'xlsx';
export const MarketablePostPricing = () => {
  const removeDrawerTabIndex = () => {
    const drawers = document.getElementsByClassName('rs-drawer-wrapper');
    Array.from(drawers).forEach(drawer => {
      drawer.removeAttribute('tabIndex');
    });
  };
  removeDrawerTabIndex();
  const params = useParams();
  const dispatch = useDispatch();
  const history = useNavigate();
  const gridRef = useRef();
  const today = new Date();
  const Gstate = useSelector(state => state);
  const Stateportfolio = Gstate.portfolio.portfolio || {};
  const currentAsset = Gstate.asset.asset || {};

  const [portfolioList, setPortfolioList] = useState([]);
  const AssetListDDL = Gstate?.assetDDL?.assetList || [];


  const previousMonthSameDate = new Date(today);
  previousMonthSameDate.setMonth(today.getMonth() - 1);
  const [selectedFromDate,setSelectedFromDate]=useState(moment(previousMonthSameDate).format("MM-DD-YYYY"));
  const [selectedToDate,setSelectedToDate]=useState(moment(today).format("MM-DD-YYYY"));
  const [gridData,setGridData]=useState([]);
  const Level = [{ BreadCrumb: "Valuations", Routes: `${UrlPath.Valuation}${params.AssetId}` }];
  const [portfolio,setSelectedPortfolio]=useState({});
  const [assetId,setAssetId]=useState(params.AssetId);
  const [saveData,setSaveData]=useState([]);
  const [toSave,setToSave]=useState(false);
const [impAsset,setimpAsset]=useState([]);
const [impPortfolio,setimpPortfolio]=useState([]);
const [impAssetLotName,setimpAssetLotName]=useState([]);
const [selectedimpAssetLot,setselectedimpAssetLot]=useState([]);
const [importReturnsDrawer, setImportReturns] = useState(false);
const [drawerData, setDrawerData] = useState();
const [workbookFile, setWorkbookFile] = useState(null);
const [importStatus,setImportStatus]=useState('Importing');
const[showreadGrid,setShowreadGrid]=useState(false);
const[readData,setReadData]=useState([]);
const [showdeleteModal,setShowdeleteModal]=useState(false);
const [portfolioValuationId,setportfolioValuationId]=useState(0);
const[isImport,setIsImport]=useState(false);
const [checkData,setCheckData]=useState([]);
const [importdt,setImportdt]=useState([]);
const [editLockedAccess,setEditLockedAccess]=useState(false);
const [showModel, setShowModel] = useState(false);
const [assetLotName, setAssetLotName] = useState("");
const [shareClassName, setShareClassName] = useState("");
const [shareClassId, setShareClassId] = useState(0);


const fetchPortfolioList = async() => {
  try{
    const list = await sbaAxios({
      url: getPortfolioMarketableList,
      params:{
        assetId: assetId
      }
    });
    setPortfolioList(list);
  }
  catch(e){
    setPortfolioList([]);
  }
};

useEffect(()=>{
  fetchPortfolioList();
}, [assetId]);

useEffect(()=>{
  console.log(impAssetLotName)
},[impAssetLotName])
  useEffect(()=>{
    document.title="Marketable Valuations";
    //dispatch(getPortFolioListAction(null));
    
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.AssetId));
    getEditLockedAccess();
  },[]);
  useEffect(() => {
    if (portfolioList.length > 0) {
      const selectedPortfolio = {
        PortfolioId: portfolioList[0].PortfolioId,
        PortfolioName: portfolioList[0].PortfolioName,
      };
      setSelectedPortfolio(selectedPortfolio);
      setimpPortfolio(selectedPortfolio);
      getValuationByAsset(selectedPortfolio.PortfolioId, params.AssetId);
      getAssetLot(selectedPortfolio.PortfolioId, params.AssetId);
    }
    else{
      setSelectedPortfolio({});
    }
    setimpAsset(currentAsset);
   
  }, [portfolioList,currentAsset]);
  const getEditLockedAccess = async  () => {
    try {
  const EditlockedAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=MarketableSecuritiesEditLockedAccess` });

  const [
    EditLockedAccessResponse,
  ] = await Promise.all([ 
    EditlockedAccessPromise    
  ]);
  setEditLockedAccess(EditLockedAccessResponse); 
    } catch (error) {
      console.error("An error occurred:", error);
      
    }
  };
  const addNewRow = async() => {
    
    const count=gridData.length;
    if(impAssetLotName.length === 0){
      setShowModel(true);
      await handleCreateNewLot();
    }
    else{
      const newRow = {valuationDate:new Date(),assetId:assetId,PortfolioId:portfolio.PortfolioId, InitialAllocationDate:new Date(),AssetLotId:impAsset[0]?.AssetLotId,AssetLotName:impAsset[0]?.AssetLotName,rowID:count,IsLocked:false };
      setGridData(val=>[newRow,...val]);
    }
   // setCheckData(val=>[newRow,...checkData]);
   
  };
  const AssetDDChanged = (e) => {
    if(e.value)
    {
      history(`${UrlPath.MarketablePostPricing}${e.value.AssetId}`);
      dispatch(getAsset(e.value.AssetId));
      getValuationByAsset(portfolio.PortfolioId,e.value.AssetId)
      getAssetLot(portfolio.PortfolioId,e.value.AssetId)
      setAssetId(e.value.AssetId);
      setimpAsset({AssetId:e.value.AssetId,AssetName:e.value.AssetName});
    }
  };
  const PortfolioDDChanged = (e) => {
    if(e.value)
    {
      setSelectedPortfolio({PortfolioId:e.value.PortfolioId,PortfolioName:e.value.PortfolioName});
      setimpPortfolio({PortfolioId:e.value.PortfolioId,PortfolioName:e.value.PortfolioName});
      getValuationByAsset(e.value.PortfolioId,params.AssetId)
      getAssetLot(e.value.PortfolioId,params.AssetId)
    }
  };

  const fromDpChanged = (e) => {
    setSelectedFromDate(moment(e).format("MM-DD-YYYY"))
  };
  const toDpChanged = (e) => {
    setSelectedToDate(moment(e).format("MM-DD-YYYY"))
  };
  const navigateBack=()=>{
    history(`${UrlPath.Valuation}${params.AssetId}`);
  }
  const getValuationByAsset = async (Id,assetId) => {
    try {
        const response = await sbaAxios({
            url: `${getMktSecValuationByAsset}${Id},${assetId},${selectedFromDate},${selectedToDate}`,
            method: 'get',
        });
        setGridData(
          response.map((item,index)=>({...item,rowID:index,valuationDate:getFormattedDate(item.valuationDate),InitialAllocationDate:getFormattedDate(item.InitialAllocationDate)}))
        );
        setCheckData(
          response.map((item,index)=>({...item,rowID:index,valuationDate:getFormattedDate(item.valuationDate),InitialAllocationDate:getFormattedDate(item.InitialAllocationDate)}))
        );
    } catch (error) {
        console.error("Error fetching valuation List from API:", error);
    }
};

const fetchShareClass = async(assetId)=>{
  let id = 0
  try{
    const list = await sbaAxios({
      url: getAssetShareClassddl+`${assetId},${true}`
    })
    for(const item of list){
      if(item.IsDefaultClass){
        id = item.ShareClassId;
        break;
      }
    }
    return id;
  }
  catch(e){
    return 0;
  }
}

const getAssetLot = async (Id,assetId) => {
  let shareClassId = await fetchShareClass(assetId)
  try {
      const response = await sbaAxios({
          url: `${getAssetLotByPortfolio}${Id},${assetId},${shareClassId}`,
          method: 'get',
      });
      if(response.length>0)
      {
      setimpAssetLotName([{AssetLotId:response[0].AssetLotId,AssetLotName:response[0].AssetLotName}]);
      setselectedimpAssetLot({AssetLotId:response[0].AssetLotId,AssetLotName:response[0].AssetLotName});
      }
      else{
        setselectedimpAssetLot([]);
        setimpAssetLotName([]);
      }
  } catch (error) {
      console.error("Error fetching valuation List from API:", error);
  }
};

const gobtnclick=()=>
{
  getValuationByAsset(portfolio.PortfolioId,params.AssetId);
  getAssetLot(portfolio.PortfolioId,params.AssetId);
}
const delColRender=(e)=>{
  const isLocked = checkData?.find(item=>item?.rowID==e.data?.rowID)?.IsLocked?editLockedAccess:true;
  return <> 
    <i className={"fa fa-trash"} style={{ color: isLocked ?  "#DF001B" : "#808080" , margin: "0 8px", cursor: "pointer" }} onClick={()=>{ isLocked &&  deleteModalpopup(e.data.PortfolioValuationId)}}></i>
  </>


}

const FormatCurrencyGrid = (params,fieldName) => {
  var num = params.data[fieldName];
  if (num !== undefined) {
    const isNegative = num < 0;
  
    const formattedValue = isNegative
      ? `($${Math.abs(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })})`
      : `$${num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    const style = isNegative ? { color: 'red' } : null;

    return <span style={style}>{formattedValue}</span>;
  } 

  else {
    return `$${0}`;
  }
};
  const currencyValueFormatter = (params,fieldName) => {
    const num = params.data[fieldName];
    if (num) {
      const formattedValue = `$${(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2})}`
      return formattedValue;
    } else {
      return `$${0}`;
    }
  };
  const RemoveThousandSep = (num) => {
    if (num !== undefined) {
      // Remove $ symbol and commas
      return parseFloat(num.replace(/[$,]/g, ''));
    } else {
      return 0;
    }
  };
  const formatDate = (params) => {
    const dateValue = params.value;
    if (dateValue) {
      return <div>{moment(dateValue).format("MM/DD/YYYY")}</div>; // Adjust the format as needed
    }
    return <div></div>;
  };
  const getFormattedDate=(value)=>{
    return value ? moment(value).format("MM-DD-YYYY") : "";
  };
  const columnDefs = [
    
    {headerName: 'Balance Date',
    field: 'valuationDate',
    filter: "agTextColumnFilter",
    cellRenderer: formatDate,
    cellEditor: DateEditor,
   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
    } ,   
    { headerName: 'AssetLotId', field: 'AssetLotId',hide:true, filter: "agTextColumnFilter" },
    { headerName: 'Lot Name', field: 'AssetLotName',editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true, cellEditor: 'agSelectCellEditor',
    cellEditorParams: (params) => (
      {
        // values: [params.data.AssetLotName],
        values: impAssetLotName.map(assetLot => assetLot.AssetLotName),
        valueListGap: 10
    }),
    // onCellValueChanged:ActionOnChange,
    filter: "agTextColumnFilter", },

    { headerName: `BMV`, field: 'BMV',
    valueSetter: params => {
      const newValue = RemoveThousandSep(params.newValue);
      if (isNaN(newValue)){
        return false; 
      }
      params.data.BMV = newValue;
      return true; 
    },
    filter: "agTextColumnFilter", 
    cellRenderer:(e)=>{return FormatCurrencyGrid(e,'BMV') },
    valueGetter:(e)=>{return currencyValueFormatter(e,'BMV')},
    cellStyle: { textAlign: "right" },

   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
    headerClass: "ag-right-aligned-header"  },

    { headerName: `Contributions`, field: 'Contributions',valueSetter: params => {
      const newValue = RemoveThousandSep(params.newValue);
      if (isNaN(newValue)) {
        return false; 
      }
      params.data.Contributions = newValue;
      return true; 
    },
    filter: "agTextColumnFilter", 
    cellRenderer:(e)=>{return FormatCurrencyGrid(e,'Contributions') },
    valueGetter:(e)=>{return currencyValueFormatter(e,'Contributions')},
    cellStyle: { textAlign: "right" },
   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
    headerClass: "ag-right-aligned-header" },

    { headerName: `Withdrawals`, field: 'Withdrawals',
    valueSetter: params => {
      const newValue = RemoveThousandSep(params.newValue);
      if (isNaN(newValue)) {
        return false; 
      }
      params.data.Withdrawals = newValue;
      return true; 
    },
    filter: "agTextColumnFilter",
    cellRenderer:(e)=>{return FormatCurrencyGrid(e,'Withdrawals') },
    valueGetter:(e)=>{return currencyValueFormatter(e,'Withdrawals')},
     cellStyle: { textAlign: "right" },
   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
    headerClass: "ag-right-aligned-header" },


    { headerName: 'Buys', field: 'Buys',valueSetter: params => {
      const newValue = RemoveThousandSep(params.newValue);
      if (isNaN(newValue)) {
        return false; 
      }
      params.data.Buys = newValue;
      return true; 
    },
    filter: "agTextColumnFilter",
    cellRenderer:(e)=>{return FormatCurrencyGrid(e,'Buys') },
    valueGetter:(e)=>{return currencyValueFormatter(e,'Buys')},
    cellStyle: { textAlign: "right" },editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,headerClass: "ag-right-aligned-header"  },
   
    { headerName: 'Sells', field: 'Sells', 
    valueSetter: params => {
      const newValue = RemoveThousandSep(params.newValue);
      if (isNaN(newValue) ) {
        return false; 
      }
      params.data.Sells = newValue;
      return true; 
    },
    filter: "agTextColumnFilter",
    cellRenderer:(e)=>{return FormatCurrencyGrid(e,'Sells') },
    valueGetter:(e)=>{return currencyValueFormatter(e,'Sells')},
    cellStyle: { textAlign: "right" },
   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
    headerClass: "ag-right-aligned-header"  },

    { headerName: 'EMV', field: 'EMV',
    valueSetter: params => {
      const newValue = RemoveThousandSep(params.newValue);
      if (isNaN(newValue)) {
        return false; 
      }
      params.data.EMV = newValue;
      return true; 
    },
    filter: "agTextColumnFilter",
    cellRenderer:(e)=>{return FormatCurrencyGrid(e,'EMV') },
    valueGetter:(e)=>{return currencyValueFormatter(e,'EMV')},
    cellStyle: { textAlign: "right" }, 
   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
    headerClass: "ag-right-aligned-header"  },
    
    { headerName: 'Return', field: 'ROR',filter: "agTextColumnFilter",   valueFormatter: params => {
      if (params && params.value !== undefined && params.value !== null) {
          const rawValue = params.value > 999 ? 999 : params.value;
          const formattedValue = parseFloat(rawValue).toFixed(2) +"%";  
          return formattedValue;
      } else {
          
          return null;
      }
  },
cellStyle: { textAlign: "right" },editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true ,headerClass: "ag-right-aligned-header"},
{
  headerName: "Is Locked",
  field:'IsLocked',
   cellRenderer: 'agCheckboxCellRenderer',
   cellEditor: 'agCheckboxCellEditor',
    maxWidth: 100,
    floatingFilter: false,
   editable:(params) => checkData?.find(item=>item.rowID==params.data.rowID)?.IsLocked?editLockedAccess:true,
},
    {
      field: "",
      headerName: "Delete",
      cellRenderer: delColRender,
      filter: false,
      editable: false,
    }

  ];
 
  

  const onSuppressKeyboardEvent = params => {
    let isTabKey = params.event.key === 'Tab';
    if (isTabKey) gridRef.current.api.stopEditing();
};

const defaultColDef = useMemo(() => {
return {
  flex: 1,
  editable: true,
  cellDataType: false,
  sortable: false,
  filter: true,
  autoHeaderHeight:true,
  suppressMovable: true,
    floatingFilter: true,
    singleClickEdit: true,
    suppressKeyboardEvent: onSuppressKeyboardEvent,
    resizable:true
};
}, []);
const onCellValueChanged = async (e) => {
  try {
    
    let updatedData = [...saveData];
    let existingSaveData=saveData.find(item=>item.rowID==e.data.rowID);
    if(existingSaveData)
    {
      existingSaveData=e.data;
      updatedData=updatedData.map(item=>{if(item.rowID===e.data.rowID)return existingSaveData; else return item })
    }
    else {
      existingSaveData=e.data;
      updatedData.push(existingSaveData);
    }
    setSaveData(val=>[...updatedData]);
    if(toSave)
    saveMktSec(updatedData);
  } catch (error) {
  
  }
};


const isEditing = () => {
  const editingCells = gridRef.current.api.getEditingCells();
  return editingCells.length > 0;
};
const StopEditingAndSave=async()=>{
  setToSave(true);
  if(isEditing())
  await gridRef.current.api.stopEditing();
  else 
  saveMktSec(saveData);
};
function validateDuplicateDate(date) {
   const occurrenceCount = gridData.filter(existingItem => 
    moment(existingItem?.valuationDate).format("MM/DD/yyyy") === moment(date).format("MM/DD/yyyy")
  ).length;
     return occurrenceCount > 1;
}
function isValidDate(date) {
  const dateObj = new Date(date);
  return dateObj.getTime() > Date.now();
}
const saveMktSec =async (saveData) => {
  console.log('save data: ', saveData)
  let ifsave = true;
  if (saveData.length == 0) {
                    
    SBNotify({ Msg: "Please edit minimum one row to Save", type: "error" });
    ifsave=false;
    setToSave(false);
}
saveData.map((item) => {
  const isduplicate=validateDuplicateDate(item.valuationDate);
  const isvalidateFuturedate=isValidDate(item.valuationDate);

  if(isvalidateFuturedate===true)
  {
    SBNotify({
      Msg: "Balane date is greater than today's date",
      type: "error",
    });
    setSaveData([]);
    ifsave=false;
  }
  else if(isduplicate===true)
  {
    SBNotify({
      Msg: "Balance date should be different for each row",
      type: "error",
    });
    setSaveData([]);
    ifsave=false;
  }
});

if (ifsave) {
    const dt = saveData.filter(item => item !== null).map(item => ({ ...item, AssetId: assetId, PortfolioId: portfolio.PortfolioId,AssetLotId:selectedimpAssetLot.AssetLotId })); 
    console.log('sending data: ', dt);

      sbaAxios({
        url: `${insertorUpdateMktSec}`,
        method: 'post',
        data: dt,
      })
        .then((response) => {
          if(response>0)
          {
          toast.success("Market Securities Valuation Updated Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          getValuationByAsset(portfolio.PortfolioId,params.AssetId);
          getAssetLot(portfolio.PortfolioId,params.AssetId)
        }
        else
        {
          toast.error("Error updating Market Securities Valuation", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        })
        .catch(() => {
          toast.error("Error updating Market Securities Valuation", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
      
  
    setSaveData([]);
    setToSave(false);
}
    
  
}
const deleteModalpopup=(Id)=>
{
    setportfolioValuationId(Id)
    setShowdeleteModal(true);

}
const deleteMktSecById = async () => {
    
  try {
    const response = await sbaAxios({
      url: `${deleteMktSec}${portfolioValuationId},${0}`,
      method: 'get',

    });
    setShowdeleteModal(false);
  
    getValuationByAsset(portfolio.PortfolioId,params.AssetId);
    getAssetLot(portfolio.PortfolioId,params.AssetId)
   
  }
  catch (error) {
    console.error("Error Deleting MktSec:", error.message);
    SBNotify({
      Msg: error.message,
      type: "error",
    });

  }

};
const importReturnsClick = () => {
  setImportStatus("Importing");
  setImportReturns(true);
  setShowreadGrid(false);
    setReadData([]);
};
const readClick=()=>
{
  setShowreadGrid(true);
  readimportbalance();
}
 const impAssetDDChanged = (e) => {
    if(e.value)
    {
      setimpAsset({AssetId:e.value.AssetId,AssetName:e.value.AssetName});
      getValuationByAsset(impPortfolio.PortfolioId,e.value.AssetId)
      getAssetLot(impPortfolio.PortfolioId,e.value.AssetId)
    }
  };
  const impPortfolioDDChanged = (e) => {
    if(e.value)
    {
      setimpPortfolio({PortfolioId:e.value.PortfolioId,PortfolioName:e.value.PortfolioName});
      getValuationByAsset(e.value.PortfolioId,impAsset.AssetId)
      getAssetLot(e.value.PortfolioId,impAsset.AssetId)
    }
  };
  const impAssetlotDDChanged = (e) => {
    if(e.value)
    {
      setselectedimpAssetLot({AssetLotId:e.value.AssetLotId,AssetLotName:e.value.AssetLotName});
    }
  };
  const ResetClick=()=>
  {
    setReadData([]);
    setShowreadGrid(false);
  }

  const handleFileChange = (event) => {
    const { name } = event.target;
    const file = event.target.files[0];
    const updatedState = { ...drawerData, [name]: file };
    setDrawerData(updatedState);

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;

          const workbook = XLSX.read(fileContent, { type: 'binary' ,cellDates: true});
        setWorkbookFile(workbookToSheetsArray(workbook));
      };

      reader.readAsBinaryString(file);
    }
  };
  const cancelImportReturns = () => {
    setShowreadGrid(false);
    setImportReturns(false);
    setReadData([]);
   
    };
    const DownloadFile=()=>
    {
      sbaAxios({
        url: DownloadMktSecFile ,
        responseType: 'blob'
    }).then((response) => {
        var downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(response);
        downloadLink.download = "MarketableBalances.xlsx";
        downloadLink.click();   
    });

    }
    const workbookToSheetsArray = (workbook) => {
      const sheetsArray = [];
      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const table = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const formattedTable = formatTableWithNulls(table);
        sheetsArray.push({ name: sheetName, table: formattedTable });
      });
      return sheetsArray;
    };
    const formatTableWithNulls = (table) => {
      const headers = table[0];
    
      if (!validateHeaders(headers)) {
        return [];
      }
    
      return table.slice(1).map((row) => {
        const isRowEmpty = row.every((value) => value === undefined || value === null);
        if (isRowEmpty) {
          return null;
        }
        const formattedRow = {};
          headers.forEach((header, index) => {
              
          if (header === 'Balance Date') {
         header='BalanceDate';
            const formattedDate = row[index];
              formattedRow[header] = formatExcelDate?formatExcelDate(formattedDate):null;
          }
          else {
            formattedRow[header] = row[index] === undefined ? null : row[index];
          }
        });
        return formattedRow;
      }).filter((row) => row !== null);
    };  
      const formatExcelDate = (inputDate) => {
         
          const date = new Date(inputDate);
          const month = date.getMonth() + 1; 
          const day = date.getDate();
          const year = date.getFullYear();
          const formattedMonth = month < 10 ? '0' + month : month;
          const formattedDay = day < 10 ? '0' + day : day;
          const formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
  
          return formattedDate;
      };
      const validateHeaders = (headers) => {
        const requiredHeaders = ["Balance Date", "Contributions", "Withdrawals", "EMV", "Buys","Sells","Return","IsLocked"];
     
        const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
        if (missingHeaders.length > 0) {
          return false;
        }
        return true;
      };
      const getMktsecImportbalance = async (lst,readdt) => {
        try {
            const response = await sbaAxios({
                
              url: `${getMktSecimport}`,
              method: 'post',
              data: lst,
            })
            if (response.length > 0) 
            {
              const rdt = readdt
               .filter((item , index)=> {
                const previousData = response.find(res => {
                  const valuationDate1 = new Date(res.valuationDate);
                  const valuationDate2 = new Date(item.valuationDate); 
                  return valuationDate1.getTime() === valuationDate2.getTime();
              });
              if(previousData?.IsLocked)
              return false;
              else 
              return true;
              });
              setImportdt(rdt);
            }
            else{
              setImportdt(readdt);
            }
            
          } catch (error) {
            console.error("Error fetching valuation List from API:", error);
        }
      }
      const readimportbalance =  () => {
        let isread=true;
        if(selectedimpAssetLot.length===0)
        {         
            SBNotify({ Msg: "Please Select Lot", type: "error" });
            isread=false;
        }
        
       if(isread)
       {
        if(workbookFile?.length>0)
        {
          const mappedData = workbookFile[0].table.map((row) => ({
            valuationDate: row.BalanceDate ? moment(row.BalanceDate).format("MM/DD/yyyy"): null,
            PortfolioName: impPortfolio.PortfolioName,
            AssetName: impAsset.AssetName,
            AssetLotName: selectedimpAssetLot.AssetLotName,
            BMV: row.BMV,
            EMV: row.EMV,
            Contributions: Number(parseFloat(row.Contributions).toFixed(4)),
            Withdrawals: Number(parseFloat(row.Withdrawals).toFixed(4)),
            Buys: Number(parseFloat(row.Buys).toFixed(4)),
            Sells:Number(parseFloat(row.Sells).toFixed(4)),
            ROR:row.Return,
            IsLocked: row.IsLocked === true ? true : false,
            PortfolioId:portfolio.PortfolioId,
            AssetId:assetId,
            AssetlotId:selectedimpAssetLot.AssetLotId,
            
          }));
          const importdt = workbookFile[0].table.map(item => 
            ({
             PortfolioId: impPortfolio.PortfolioId,
             AssetId: impAsset.AssetId,
             AssetLotId: selectedimpAssetLot.AssetLotId,
             MktDate: item.BalanceDate ? moment(item.BalanceDate).format("MM/DD/yyyy") : null
            })
            
          );
        const resp=getMktsecImportbalance(importdt,mappedData);
       
      setReadData(mappedData);
         if(mappedData.length>0)
         {
      setImportStatus("Import");
         }
      
        }
        else {
          SBNotify({ type: "error", Msg: "Please Select Any File To Import" });
          setShowreadGrid(false);
          setImportStatus('Importing');  
        }
      }
      else{
        setShowreadGrid(false);
        setImportStatus('Importing');  
      }
      };
      const ImpFormatCurrencyGrid = (params) => {
        var num = params.value;
        if (num !== undefined && num != null) {
          if (num === 0) {
            return '$0.00'
          } else { 
            const isNegative = num < 0;
            const formattedValue = isNegative
              ? `($${Math.abs(num).toLocaleString('en-US', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })})`
              : `$${num.toLocaleString('en-US', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}`;
            const style = isNegative ? { color: 'red' } : null;
            return <span style={style}>{formattedValue}</span>;
          }
        } else {
          return <span></span>; 
        }
      };
    
      
      const importcolumnDefs = [
    
        {headerName: 'Balance Date',
        field: 'valuationDate',
        filter: "agTextColumnFilter",
        cellRenderer: formatDate,
        editable: false} ,  
        { headerName: 'Portfolio Name', field: 'PortfolioName',editable:false, 
        filter: "agTextColumnFilter", },
        { headerName: 'Asset Name', field: 'AssetName',editable:false, 
        filter: "agTextColumnFilter", }, 
             { headerName: 'Lot Name', field: 'AssetLotName',editable:false, 
        filter: "agTextColumnFilter", },
        { headerName: `BMV`, field: 'BMV',
        filter: "agTextColumnFilter", cellRenderer: ImpFormatCurrencyGrid,cellStyle: { textAlign: "right" },editable:false,headerClass: "ag-right-aligned-header"  },
        { headerName: `Contributions`, field: 'Contributions',
        filter: "agTextColumnFilter", cellRenderer: ImpFormatCurrencyGrid,cellStyle: { textAlign: "right" },editable:false,headerClass: "ag-right-aligned-header" },
        { headerName: `Withdrawals`, field: 'Withdrawals',filter: "agTextColumnFilter", cellRenderer: ImpFormatCurrencyGrid,cellStyle: { textAlign: "right" },editable:false,headerClass: "ag-right-aligned-header" },
        { headerName: 'Buys', field: 'Buys',filter: "agTextColumnFilter",cellRenderer: ImpFormatCurrencyGrid,cellStyle: { textAlign: "right" },editable:false,headerClass: "ag-right-aligned-header"  },
        { headerName: 'Sells', field: 'Sells',filter: "agTextColumnFilter",cellRenderer: ImpFormatCurrencyGrid,cellStyle: { textAlign: "right" },editable:false,headerClass: "ag-right-aligned-header"  },
          { headerName: 'EMV', field: 'EMV', filter: "agTextColumnFilter", cellRenderer: ImpFormatCurrencyGrid, cellStyle: { textAlign: "right" }, editable: false, headerClass: "ag-right-aligned-header" },
          { headerName: 'Return', field: 'ROR', filter: "agTextColumnFilter", valueFormatter: params => {
          if (params && params.value !== undefined && params.value !== null) {
              const rawValue = params.value > 999 ? 999 : params.value;
              const formattedValue = parseFloat(rawValue).toFixed(2)+"%";  
              return formattedValue;
          } else {
              
              return null;
          }
      },
          cellStyle: { textAlign: "right" }, editable: false, headerClass: "ag-right-aligned-header"
        },
        {
          headerName: "Is Locked",
          field: 'IsLocked',
          disabled: true,
          maxWidth: 100,
          cellRenderer: 'agCheckboxCellRenderer',
          floatingFilter: false,
          editable: false,
        },

    ]
    const importMktSec = () => {
       let ifsave = true;
       if (readData.length == 0) {
                         
         SBNotify({ Msg: "Please edit minimum one row to Save", type: "error" });
         ifsave=false;
     }
    
     const dateCount = {}; 
     readData.map((item) => {
       if (ifsave) {
         const isvalidateFuturedate = isValidDate(item.valuationDate); // Check future date
         if (dateCount[item.valuationDate]) {
           dateCount[item.valuationDate]++;
         } else {
           dateCount[item.valuationDate] = 1;
         }
         if (dateCount[item.valuationDate] > 1) {
           SBNotify({
             Msg: `Balance date should be different for each row`,
             type: "error",
           });
           ifsave = false; 
         }
         
         else if (isvalidateFuturedate === true) {
           SBNotify({
             Msg: "Balance date is greater than today's date",
             type: "error",
           });
          
           ifsave = false;
         }
       }
     });
     if (ifsave) {
      setIsImport(true);
      const dt = importdt;
          
           
           sbaAxios({
             url: `${insertorUpdateMktSec}`,
             method: 'post',
             data: dt,
           })
             .then((response) => {
               toast.success("Imported Updated Successfully", {
                 position: "top-right",
                 autoClose: 5000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: false,
                 draggable: true,
                 progress: undefined,
                 theme: "light",
               });
              
               getValuationByAsset(portfolio.PortfolioId,params.AssetId);
               getAssetLot(portfolio.PortfolioId,params.AssetId);
             })
             .catch(() => {
               toast.error("Error updating in import", {
                 position: "top-right",
                 autoClose: 5000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: false,
                 draggable: true,
                 progress: undefined,
                 theme: "light",
               });
             });
           
       
         setSaveData([]);
         setReadData([]);
         setToSave(false);
         setIsImport(false);
         setImportReturns(false);
             
         setImportStatus("Import");
     }
     };

    const handleCreateNewLot = async() =>{
      const fetchShareClass = async()=>{
        try{
          const list = await sbaAxios({
            url: getAssetShareClassddl+`${impAsset.AssetId},${true}`
          })
          for(const item of list){
            if(item.IsDefaultClass){
              setShareClassName(item.ShareClassName);
              setShareClassId(item.ShareClassId);
              break;
            }
          }
        }
        catch(e){
        }
      }

      const getAssetLotName =()=>{
        let name = shareClassName
        // Get today's date
        let today = new Date();
        // Format the date as dd/mm/yy
        let dayOfMonth = String(today.getDate()).padStart(2, '0');
        let month = String(today.getMonth() + 1).padStart(2, '0');
        let year = String(today.getFullYear()).slice(-2);
        return name + " - " + month + "/" + dayOfMonth + "/" + year;
      }

      await fetchShareClass();
      setAssetLotName(getAssetLotName());
    }

    const createNewLot = async () =>{
      if(impAssetLotName.length===0){

        const postData = async () =>{
          const data = {
            assetLotName: assetLotName,
            portfolioId: portfolioId,
            assetId: assetId,
            shareClassId: shareClassId,
            initAllocationDate: new Date().toISOString()
          }
          try{
            await sbaAxios({
              url:insertNewAssetLot,
              method: 'post',
              data:data
            })
            toast.success("New Asset Lot created successfully.");
          }
          catch(e){
            toast.error("Unable to create Asset Lot.")
          }
        }
  
        const portfolioId = impPortfolio.PortfolioId
        const assetId = impAsset.AssetId;
  
        await postData();
        await getAssetLot(portfolioId, assetId)
        setShowModel(false)
      }
      else{
        toast.error("Asset Lot already exists.")
      }
     }

  return (
    <>
      <TopBar label={"Marketable Valuations"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-2">
              <label className="mb-1">Security Name</label>
              <SBAComboBox 
                value={currentAsset}
              data={AssetListDDL?.filter(item=>item.IsMarketable)}
              textField="AssetName"
              valueField="AssetId"
              onChange={AssetDDChanged}
               />
            </div>
            <div className="col-12  col-md-2">
              <label className="mb-1">Portfolio Name</label>
              <SBAComboBox 
              data={portfolioList}
              //  className="w-50"
                onChange={PortfolioDDChanged} 
                  textField={"PortfolioName"}
                 valueField={"PortfolioId"}
                 value={portfolio}
                />
            </div>
            <div className="col-12  col-md-3 d-flex gap-4">
              <div>
              <label className="mb-1">Start Date</label>
              <div className="d-block">
                <SBDatePicker 
                 value={moment(selectedFromDate)}
                format="MM/DD/YYYY"
                onChange={fromDpChanged} />
              </div>
              </div>
              <div>
            <label className="mb-1">End Date</label>
              <div className="d-block">
                <SBDatePicker 
                value={moment(selectedToDate)}
                format="MM/DD/YYYY"
                onChange={toDpChanged} />
              </div>
            </div>
            </div>
           
            <div className="col-12 col-md-5 row-items ">
              <div className="ms-auto row-items d-flex justify-content-end">
              <button type="submit" className="p-sm-btn mx-1" onClick={gobtnclick}>
                Go
              </button>
              <button type="submit"  className="p-sm-btn mx-1" onClick={importReturnsClick}>Import</button>
                                                    <button type="button" className="p-sm-btn mx-1" onClick={StopEditingAndSave}>Save</button>
                                                    <button
                    type="button"
                    className="p-sm-btn mx-1"
                    onClick={() => {
                      exportToExcelUsingRef(
                        gridRef,
                        "MarketablePostPricing.xlsx"
                      );
                    }}
                  >
                    <img src={download} alt="" /> Export
                  </button>
              <button 
              type="submit" 
              className="s-sm-btn mx-1"
              onClick={()=>{navigateBack()}}
              >
                Cancel
              </button>

              </div>
             
            </div>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 bg-white  rounded">
        <div
                  className="ag-theme-alpine"
                  style={{ height: "70vh", width: "100%" }}
                > <div style={{ marginBottom: '10px' }}>
                <button  type="submit"  className="p-sm-btn mx-1"  onClick={addNewRow}> <i className="fa-solid fa-plus" />Add New Record</button>
              </div>
            <AgGridReact  ref={gridRef}  defaultColDef={defaultColDef} columnDefs={columnDefs} rowData={gridData}  onCellValueChanged={onCellValueChanged}></AgGridReact>
          </div>
        </div>
       
      </div>
      <SBADrawer
              open={importReturnsDrawer}
              setOpen={setImportReturns}
              close={false}
              title={<span className="d-flex justify-content-between"><span>Marketable Valuations</span> <Link onClick={DownloadFile}> Download Template</Link></span>}
              size="80vw"
              style={{ width: '80vw' }}
            >
              <div> {isImport ?  <><LoadingScreen/></> : <>
             
                <div className="col-lg-12 row m-0 mb-4 gap-2">
                  <div className="row">
                  <div className="col-md-4">
                    <div className="mb-4">
                      <span className="fw-medium">Portfolio Name</span>
                      <SBAComboBox 
              data={portfolioList}
                onChange={impPortfolioDDChanged} 
                  textField={"PortfolioName"}
                 valueField={"PortfolioId"}
                 value={impPortfolio}
                 popupSettings={{ className: "modalDD" }}
                />
                  
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <span className="fw-medium">Asset Name</span>                    
                   <SBAComboBox 
                value={impAsset}
              data={AssetListDDL?.filter(item=>item.IsMarketable)}
              textField="AssetName"
              valueField="AssetId"
              onChange={impAssetDDChanged}
              popupSettings={{ className: "modalDD" }}
               />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <span className="fw-medium">Asset Lot Name</span>                    
                      <div style={{display:'flex', alignItems:'center'}}>
                      <SBAComboBox 
                      value={selectedimpAssetLot}
                      data={impAssetLotName}
                      textField="AssetLotName"
                      valueField="AssetLotId"
                      onChange={impAssetlotDDChanged}
                      popupSettings={{ className: "modalDD" }}
                  />
                  <span className="fw-medium">
                        <button 
                          type="submit" 
                          className="p-sm-btn mx-1" 
                          onClick={()=>{
                            handleCreateNewLot(); 
                            setShowModel(true);
                          }}
                        >
                          <i className="fa-solid fa-plus" />
                        </button>
                    </span>
                      </div>
                    </div>
                    
                  </div>
                  </div>
                  <div className="row">
                  <div className="col-md-4">
                    <div className="mb-4">
                      <span className="fw-medium">Select File</span>
                      <input type="file"  accept=".xls,.xlsx" name="selectedFile" onChange={handleFileChange}/>
                    </div>
                  </div>
                  <div className="col-md-4">
                    </div>
                <div className="col-md-4 d-flex justify-content-end">
                  <button className="p-sm-btn mx-1" onClick={readClick}>Read</button>
                  <button className="p-sm-btn mx-1"  disabled={importStatus==='Importing'} onClick={()=>{setImportStatus('Importing');importMktSec()}}>Import</button>
                  <button className="p-sm-btn mx-1" onClick={ResetClick}>Reset</button>
                  <button className="s-sm-btn mx-1" onClick={cancelImportReturns}>Cancel</button>
                 
                </div>
                </div>
                </div>               
                {showreadGrid &&
                   <div class="col-lg-12 col-md-12 bg-white  rounded">
                   <div
                             className="ag-theme-alpine"
                             style={{ height: "70vh", width: "100%" }}
                           > <div style={{ marginBottom: '10px' }}>
                  <AgGridReact   defaultColDef={defaultColDef} columnDefs={importcolumnDefs} rowData={readData}
></AgGridReact>   
</div>
</div></div> 
}    
</>
         }
              </div>
            </SBADrawer>
             {/* MktSec Delete Modal ----- */}
      <Modal show={showdeleteModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowdeleteModal(false);
          }}
        >
          <Modal.Title>
            Delete Marketable Valuations
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want delete this Portfolio Valuation?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setShowdeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={deleteMktSecById}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal for create lot confirmation */}
      {showModel && (
        <Modal show={showModel} onHide={() => setShowModel(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Asset Lot Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-6">
                <label>Portfolio Name:</label>
              </div>
              <div className="col-6">
                <p>{impPortfolio.PortfolioName}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label>Asset Name:</label>
              </div>
              <div className="col-6">
                <p>{impAsset.AssetName}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label>Asset Lot Name:</label>
              </div>
              <div className="col-6">
              <Form>
                <Form.Group className="mb-4">
                  <Form.Control
                    className="form-control w-75"
                    type="text"
                    value={assetLotName}
                    onChange={(e)=>{setAssetLotName(e.target.value)}}
                    autoFocus
                  />
                </Form.Group>
              </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={createNewLot}
          >
            Create Lot
          </button>
        </Modal.Footer>
      </Modal>
      )}
      <ToastContainer />
    </>
  );
};
class DateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(props.value),
    };
  }

  getValue() {
    return this.state.date;
  }

  afterGuiAttached() {
    // Focus on the DatePicker input field after it's attached
    this.datePicker.focus();
  }

  render() {
    return (
      <DatePicker
        ref={(el) => (this.datePicker = el)}
        value={this.state.date}
        onChange={(event) => this.setState({ date: event.value })}
      />
    );
  }
}